<template>
<div class="col-lg-6 mt-lg-0 mt-4">
    <div class="wow fadeInUp" data-wow-duration="1500ms">
        <div class="title-section">
            <div class="subtitle-hr d-flex align-items-center">
                <h6 class="subtitle theme-color text-uppercase position-relative">Anchor Assessments</h6>
                <hr>
            </div>
            <h2 class="title text-md-left text-center f-20">Don’t Miss Out, Explore Other Anchor Assessments Here:</h2>
        </div>
    </div>
    <div class="mt-4 wow fadeInUp" data-wow-duration="1500ms">
        <div class="row team-slider owl-carousel owl-theme">

            <div class="col-12" v-for="assessment in assessments" :key="assessment.name">
                <div class="border bg-white transition text-center p-3">
                    <div class="rounded-circle overflow-hidden team-img mx-auto">
                        <img :src="assessment.image">
                    </div>
                    <div class="team-desc">
                        <h6 class="f-18 my-2 theme-color">{{assessment.name}}</h6>
                         <!-- <button type="input" class="mt-4 btn theme-btn contact-form-btn border-0" value="Send" @click="submit()">Learn more</button> -->
                        <a class="mt-4 btn theme-btn contact-form-btn border-0" :href="assessment.link">Learn more</a>
                    </div>
                </div>
            </div>

           
        </div>
    </div>
</div>
</template>

<script>

let image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThBjHwQwH-UzQ6V7fdTMd24658V8keCGjLlrj4AoE6Q95SLOiStUSpBzmqvD7_1Ni_WM0&usqp=CAU";
import {assessmentsList} from '../landing-pages/assessmentListing';

export default {
    name: "assessmentListing",
   
    
    data() {
        return {
            assessments:assessmentsList

        }
    },
    methods: {
         submit()
        {
         Swal.fire('Not available as yet','This assessment is coming soon');
        }

    },
    mounted() {
        
       

        //alert("Product type: "+this.product);
    }
}
</script>
